import { useHistory } from 'react-router-dom';

import NoFeedback from 'assets/assetsV1/illustrations/newIllustrations/noFeedback.svg';

import { pushFeedbackParams } from 'constants/helper';

import { AgGridTable } from 'uiToolkitV1/AgGridWrapperV2';
import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { useAgGridForFeedbackShareForTeam } from './hooks/useAgGridForFeedbackShareForTeam';

const NoRowsOverlayComponent = () => (
  <EmptyScreen
    heading="Nothing to see here, yet!"
    description=""
    illustrationSrc={NoFeedback}
    illustrationStyle={{ marginTop: '90px' }}
  />
);

const FeedbackSharedByMyTeam = ({ gridRef }: { gridRef?: unknown }) => {
  const { columnDefs, defaultColDef, rowData } = useAgGridForFeedbackShareForTeam();
  const history = useHistory();

  const rowClickHandler = ({ data, column }) => {
    const { uuid: feedbackId } = data.requestDetails ?? data.comment ?? {};
    const formType = 'SHOW_RECEIVED';

    if (column.colId === 'kebab-menu') {
      //  To prevent event bubbling.
    } else {
      // @ts-expect-error not typed
      pushFeedbackParams({
        history,
        formType,
        typeMapped: true,
        feedbackId,
      });
    }
  };

  return (
    <PaperWithShadow px={3}>
      <AgGridTable
        ref={gridRef}
        defaultColDef={defaultColDef}
        columnDefs={columnDefs}
        rowData={rowData}
        kebabMenuIsRowSpecific={false}
        domLayout="autoHeight"
        animateRows={false}
        rowHeight={74}
        containerAutoHeight
        pagination
        suppressPaginationPanel={rowData?.length < 6 || rowData?.length === undefined || rowData?.length === 0}
        paginationPageSize={10}
        showSidebarToggle={false}
        onCellClicked={rowClickHandler}
        noRowsOverlayComponent={NoRowsOverlayComponent}
      />
    </PaperWithShadow>
  );
};

export { FeedbackSharedByMyTeam };
